import { buildInteractorDirectAction, buildInteractorDirectActionNoParams } from './base';
import { sofiFormActions } from '../slices/sofiFormSlice';

export const updateInteractor = buildInteractorDirectAction(sofiFormActions.update);
export const resetInteractor = buildInteractorDirectActionNoParams(sofiFormActions.reset);
